/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Realm_Org_HintInputs */



/**
* | output |
* | --- |
* | "Changes here apply to everyone in your organization." |
*
* @param {Settings_Realm_Org_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_realm_org_hint = /** @type {((inputs?: Settings_Realm_Org_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Realm_Org_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen hier gelten für alle in deiner Organisation.")
	return /** @type {LocalizedString} */ ("Changes here apply to everyone in your organization.")
});